<template>
  <div style="height: 100%">
    <!--    数据汇总-->
    <div class="dataSummary">
      <div class="tytitle">
        缴费数据
      </div>
      <div class="dataSummary_body">
        <div class="dataSummary_title">
          <span>日数据</span>
          <p @click="sunClick">
              <span>
              {{ formatDate }}
              </span>
            <img src="../../assets/img/receptionUnit/date.png" alt="">
          </p>
        </div>
        <div class="dataSummary_content">
          <div v-for="(item,index) in sunData" :key="index">
            <div>
              <img v-if="item.imgPath" :src="item.imgPath" alt="">
              <span>{{ item.title }}</span>
            </div>
            <div>
              <span>{{ item.value }}</span>
              <span>{{ item.unit }}</span>
            </div>
          </div>
        </div>

        <div class="dataSummary_title">
          <span>汇总数据</span>
          <p @click="summaryClick">
              <span>
              {{ dateObj.startDate }} - {{ dateObj.endDate }}
              </span>
            <img src="../../assets/img/receptionUnit/date.png" alt="">
          </p>
        </div>
      </div>
      <div class="dataSummary_content">
        <div v-for="(item,index) in summaryData" :key="index">
          <div>
            <img v-if="item.imgPath" :src="item.imgPath" alt="">
            <span>{{ item.title }}</span>
          </div>
          <div>
            <span>{{ item.value }}</span>
            <span>{{ item.unit }}</span>
          </div>
        </div>
      </div>
    </div>
    <van-popup v-model="show" position="bottom" :style="{ height: '30%' }">
      <van-datetime-picker
          v-model="date"
          type="date"
          title="选择年月日"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="dateConfirm"
          @cancel="dateCancel"
      />
    </van-popup>
    <van-calendar color="#208fff" :min-date="minDate"
                  :max-date="maxDate" v-model="summaryShow" :default-date="defaultDate" type="range"
                  @confirm="onConfirm"/>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: "dataSummary",
  data() {
    return {
      date: '',
      dateObj: {
        startDate: moment().startOf('year').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD')
      },
      show: false,
      summaryShow: false,
      sunData: [
        {
          title: '总金额',
          value: '',
          imgPath: '',
          unit: '元',
          key: 'payAmt_all',
        },
        {
          title: '订单数',
          value: '',
          imgPath: '',
          unit: '笔',
          key: 'totalPay_all',
        },
        {
          title: '伙食费',
          value: '',
          imgPath: require('../../assets/img/receptionUnit/meal.png'),
          unit: '元',
          key: 'payAmt_meal',
        },
        {
          title: '订单数',
          value: '',
          imgPath: require('../../assets/img/receptionUnit/order.png'),
          unit: '笔',
          key: 'totalPay_meal',
        },
        {
          title: '交通费',
          value: '',
          imgPath: require('../../assets/img/receptionUnit/transport.png'),
          unit: '元',
          key: 'payAmt_transport',
        },
        {
          title: '订单数',
          value: '',
          imgPath: require('../../assets/img/receptionUnit/order.png'),
          unit: '笔',
          key: 'totalPay_transport',
        },
      ],
      summaryData: [
        {
          title: '总金额',
          value: '',
          imgPath: '',
          unit: '元',
          key: 'payAmt_all',
        },
        {
          title: '订单数',
          value: '',
          imgPath: '',
          unit: '笔',
          key: 'totalPay_all',
        },
        {
          title: '伙食费',
          value: '',
          imgPath: require('../../assets/img/receptionUnit/meal.png'),
          unit: '元',
          key: 'payAmt_meal',
        },
        {
          title: '订单数',
          value: '',
          imgPath: require('../../assets/img/receptionUnit/order.png'),
          unit: '笔',
          key: 'totalPay_meal',
        },
        {
          title: '交通费',
          value: '',
          imgPath: require('../../assets/img/receptionUnit/transport.png'),
          unit: '元',
          key: 'payAmt_transport',
        },
        {
          title: '订单数',
          value: '',
          imgPath: require('../../assets/img/receptionUnit/order.png'),
          unit: '笔',
          key: 'totalPay_transport',
        },
      ],
      minDate: new Date(2010, 0, 1),
      maxDate: new Date(2030, 10, 1),
      vde: '',
      defaultDate: []
    }
  },
  mounted() {
    this.vde = this.$route.query.vde
    let date = new Date() // 获取时间
    let year = date.getFullYear() // 获取年
    let month = date.getMonth()  // 获取月
    let strDate = date.getDate() // 获取日
    this.date = new Date(year, month, strDate)
    this.defaultDate = [new Date(moment().startOf('year').format('YYYY-MM-DD')), this.date]
    this.getSunData()
    this.getSummaryData()
  },
  computed: {
    formatDate() {
      return moment(this.date).format('YYYY-MM-DD')
    }
  },
  methods: {
    getSunData() {
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0
      })
      this.request({
        url: '/travel/h5/showDailyTravelData',
        params: {
          startDate: moment(this.date).format("YYYY-MM-DD"),
          endDate: moment(this.date).format("YYYY-MM-DD"),
          deptId: this.vde
        }
      }).then(res => {
        this.$toast.clear()
        if (res.status == 200) {
          let data = res.data.result
          this.sunData.map(item => {
            item.value = data[item.key] || 0
          })
        }


      })
    },
    getSummaryData() {
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0
      })
      this.request({
        url: '/travel/h5/showDailyTravelData',
        params: {
          startDate: this.dateObj.startDate, endDate: this.dateObj.endDate,
          deptId: this.vde
        }
      }).then(res => {
        this.$toast.clear()
        if (res.status == 200) {
          let data = res.data.result
          this.summaryData.map(item => {
            item.value = data[item.key] || 0
          })
        }
      })
    },
    sunClick() {
      this.show = true
    }
    ,
    dateConfirm(val) {
      this.date = val
      this.show = false
      this.getSunData()
    }
    ,
    dateCancel() {
      this.show = false

    }
    ,
    summaryClick() {
      this.summaryShow = true
    }
    ,
    onConfirm(val) {
      if (val) {
        console.log(val)
        this.defaultDate = val
        this.dateObj.startDate = moment(val[0]).format('YYYY-MM-DD')
        this.dateObj.endDate = moment(val[1]).format('YYYY-MM-DD')
      }
      this.summaryShow = false
      this.getSummaryData()
    }
  }
}
</script>
<style lang="scss" scoped>
.tytitle {
  height: 44px;
  line-height: 44px;
  font-size: 17px;
  color: #333333;
  letter-spacing: 0;
  text-align: center;
  font-weight: 600;
  background: #fff;
  border-bottom: 0.5px solid #ebedf0;
}
.dataSummary {

  height: 100%;
  background: #fff;
  overflow-y: auto;

  .dataSummary_title {
    height: 55px;
    line-height: 55px;
    display: flex;
    justify-content: space-between;
    padding: 0 15px;
    span{

      font-size: 16px;
      color: #464A4C;
      letter-spacing: 0;
      font-weight: 500;
    }
    p {
      display: flex;
      align-items: center;

      font-size: 16px;
      color: #464A4C;
      letter-spacing: 0;
      font-weight: 500;

      span {

        font-weight: 400 !important;
      }

      img {
        height: 15px;
        width: 15px;
        margin-left: 10px;
      }
    }
  }

  .dataSummary_content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0 15px;

    > div {
      width: 40%;
      margin-bottom: 10px;
      height: 40px;
      background: #ECF7FF;
      border-radius: 10px;
      padding: 20px 15px;

      > div:nth-of-type(1) {
        display: flex;

        img {
          width: 17px;
          margin-right: 10px;
          //height: 15px;
        }

        span {

          font-size: 16px;
          color: #464A4C;
          letter-spacing: 0;
          font-weight: 400;
        }
      }

      > div:nth-of-type(2) {
        display: flex;
        justify-content: space-between;
        margin-top: 8px;

        span:nth-of-type(1) {

          font-size: 22px;
          color: #464A4C;
          letter-spacing: 0;
          font-weight: 500;
        }

        span:nth-of-type(2) {

          font-size: 14px;
          color: #464A4C;
          letter-spacing: 0;
          font-weight: 500;
        }
      }
    }
  }
}
</style>
